(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["film"] && !Shopify.designMode) return;
  try {
    
  class FilmVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.toggle = this.querySelector('[data-film-sound]');
      if (!this.video || !this.toggle) return;
      this.onLabel = this.querySelector('[data-film-sound-on]');
      this.offLabel = this.querySelector('[data-film-sound-off]');
      this.toggle.addEventListener('click', () => this.toggleSound());
    }

    toggleSound() {
      const muted = !this.video.muted;
      this.video.muted = muted;
      if (!muted) this.video.play();
      this.toggle.setAttribute('aria-pressed', String(!muted));
      if (this.onLabel && this.offLabel) {
        this.onLabel.hidden = !muted;
        this.offLabel.hidden = muted;
      }
    }
  }

  if (!customElements.get('film-video')) {
    customElements.define('film-video', FilmVideo);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
